import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomer, BackendQueryCustomerArgs } from 'src/types/backend';

import { FRAGMENT_ROWS_ALLOCATION } from './schema';

const QUERY = gql`
  query CustomerRowsAllocation($id: ID!) {
    customer(id: $id) {
      id
      rowsAllocationPerChannel {
        ...RowsAllocationPerChannel
      }
    }
  }
  ${FRAGMENT_ROWS_ALLOCATION}
`;

type Variables = BackendQueryCustomerArgs;
type Result = Pick<BackendCustomer, 'id' | 'rowsAllocationPerChannel'>;

export const queryCustomerRowsAllocation = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  return getSingleProp<Result>(result.data);
};
